<template>
  <div class="container" v-bind:class="`-mode-${[$root.mode]}`">
    <div class="row">
      <div class="col-12" v-if="$root.mode === 'xs' || $root.mode === 'sm'">
        <announcements :acf="announcementsacf"></announcements>
        <newsFeeds :acf="newsFeedsacf" />
        <extLinkCards :acf="extLinkCardsacf" />
        <extLinkCardsWd :acf="extLinkCardsWdacf" />
      </div>
      <div class="col-12" v-else>
        <div class="row">
          <div class="col-9">
            <announcements :acf="announcementsacf"></announcements>
            <extLinkCards :acf="extLinkCardsacf" />
            <extLinkCardsWd :acf="extLinkCardsWdacf" />
          </div>
          <div
            class="col-3"
            style="background: #f7eded;
    border-radius: 10px;
    margin: 15px 0px;"
          >
            <newsFeeds :acf="newsFeedsacf" />
          </div>
        </div>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script>
import extLinkCards from "../shared/extlinkcards.vue";
import extLinkCardsWd from "../shared/extlinkcardswd.vue";
import announcements from "../shared/announcements.vue";
import newsFeeds from "../shared/newsfeed-component.vue";

export default {
  components: { extLinkCards, extLinkCardsWd, announcements, newsFeeds },
  props: [
    "newsFeedsacf",
    "extLinkCardsacf",
    "extLinkCardsWdacf",
    "announcementsacf",
  ],
  data() {
    return {
      content: {},
    };
  },
  name: "wrapper",
  created() {},
};
</script>

<style>
.for-professionals {
  padding: 7rem 0 1rem 0;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
